/**
 * @generated SignedSource<<b2f67afcb9508c55ee076433f1a7641c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type stakeholdersList_StakeholdersListQuery$variables = {
  initialEnd: string;
  initialStart: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  search?: string | null | undefined;
};
export type stakeholdersList_StakeholdersListQuery$data = {
  readonly stakeholders: {
    readonly stakeholders: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"stakeholderRow_stakeholder">;
    }>;
    readonly totalCount: number;
  };
};
export type stakeholdersList_StakeholdersListQuery = {
  response: stakeholdersList_StakeholdersListQuery$data;
  variables: stakeholdersList_StakeholdersListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "initialEnd"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "initialStart"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "endDate",
    "variableName": "initialEnd"
  },
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "initialStart"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholdersList_StakeholdersListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "StakeholdersPayload",
        "kind": "LinkedField",
        "name": "stakeholders",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholders",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "args": (v9/*: any*/),
                "kind": "FragmentSpread",
                "name": "stakeholderRow_stakeholder"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "stakeholdersList_StakeholdersListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "StakeholdersPayload",
        "kind": "LinkedField",
        "name": "stakeholders",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Stakeholder",
            "kind": "LinkedField",
            "name": "stakeholders",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "MonthlyCost",
                "kind": "LinkedField",
                "name": "monthlyCosts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "month",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1616737a3fa60dd70b35b2cfaddb0b67",
    "id": null,
    "metadata": {},
    "name": "stakeholdersList_StakeholdersListQuery",
    "operationKind": "query",
    "text": "query stakeholdersList_StakeholdersListQuery(\n  $search: String\n  $limit: Int\n  $offset: Int\n  $initialStart: String!\n  $initialEnd: String!\n) {\n  stakeholders(search: $search, limit: $limit, offset: $offset) {\n    totalCount\n    stakeholders {\n      id\n      name\n      ...stakeholderRow_stakeholder_4kYbGF\n    }\n  }\n}\n\nfragment stakeholderRow_stakeholder_4kYbGF on Stakeholder {\n  name\n  monthlyCosts(startDate: $initialStart, endDate: $initialEnd) {\n    month\n    amount\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "bb69550bbfe8060c67cbf3b653ce532d";

export default node;
